/**
 * Bootstrap de la app.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "@core/auth/AuthProvider";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
